export class UserIdentification {
    id: number;
    cardType: string;
    cardNumber: string;
}


// WEBPACK FOOTER //
// ./src/app/models/users/userIdentifications.ts